'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _transformers = require('../utils/transformers');

var _lengthToEmsTransformer = require('./lengthToEmsTransformer');

var _lengthToEmsTransformer2 = _interopRequireDefault(_lengthToEmsTransformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the base font size will always be 16 for media queries
var rootPxToEmTransformer = (0, _transformers.transformValue)(_lengthToEmsTransformer2.default, _ramda.__, { baseFontSize: 16 }, null);

exports.default = rootPxToEmTransformer;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/transformers/rootPxToEmTransformer.js
// module id = 675
// module chunks = 168707334958949